// extracted by mini-css-extract-plugin
export const subFooterContainer = "SubFooter-module--sub-footer-container--1Q6mt";
export const copyright = "SubFooter-module--copyright--6RqyZ";
export const subFooterNav = "SubFooter-module--sub-footer-nav--3eH-l";
export const onetrustButton = "SubFooter-module--onetrust-button--17nTz";
export const backToTop = "SubFooter-module--back-to-top--3vkv2";
export const backToTopIcon = "SubFooter-module--back-to-top-icon--vkBPL";
export const searchContainer = "SubFooter-module--search-container--laU_U";
export const search = "SubFooter-module--search--1rJNd";